import { requestPayment } from 'Cloud/Application/Payment';
import { useCallback } from 'react';
import { useGoToSubscriptions } from 'reactApp/hooks/useGoToSubscriptions';
import { EPaymentGa, sendPaymentGa } from 'reactApp/utils/paymentGa';

import { EShowTariffType, IModalCallbacks, Subscription } from '../UploadBigFileDialog.types';

export const useBigFileModalCallbacks = ({
    closeModal,
    skipFileLoading,
    continueFileLoading,
    sendGa,
    subscription,
    fileSizeBytes,
}): IModalCallbacks => {
    const { trialSubscription, showTariffType } = <Subscription>subscription;
    const { goToSubscriptions } = useGoToSubscriptions();

    const sendPayment = useCallback(
        (label) => {
            sendPaymentGa({ action: EPaymentGa.bigFileModal, label, size_offer: fileSizeBytes });
        },
        [fileSizeBytes]
    );

    const onSkip = useCallback(() => {
        sendGa('skip', showTariffType);
        sendPayment('cancel');
        skipFileLoading();
        closeModal();
    }, []); // closeModal передается из старого кода, коллбек пересоздавать не нужно при его изменении

    const onClose = useCallback(() => {
        sendGa('close', showTariffType);
        sendPayment('close');
        skipFileLoading();
        closeModal();
    }, []);

    const onRequestPayment = useCallback(() => {
        const onSuccess = (gaLabel) => () => {
            closeModal();
            sendGa(gaLabel);
        };

        sendGa('request-payment', showTariffType);
        sendPayment('click');
        // Пользователю с неактивированным триалом в 128ГБ
        // показываем окно с предложением оплатить триал.
        // Оверквотеру триал не показываем.
        if (showTariffType === EShowTariffType.TRIAL) {
            // eslint-disable-next-line @typescript-eslint/ban-ts-comment
            // @ts-ignore
            requestPayment({
                productId: trialSubscription.id,
                forceFastCheckout: true,
                onSuccess: onSuccess('buy-trial'),
                afterUpdate: continueFileLoading,
            });

            return;
        }

        // открываем страницу /subscriptions#pro
        if (showTariffType === EShowTariffType.PRO) {
            // eslint-disable-next-line @typescript-eslint/ban-ts-comment
            // @ts-ignore
            skipFileLoading();
            closeModal();
            goToSubscriptions({ inSameTab: true, anchor: 'pro', query: 'from=big-file' });
            return;
        }

        // Бесплатному пользователю
        // показываем окно фастчекаута
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-ignore
        requestPayment({
            forceFastCheckout: true,
            onSuccess: onSuccess('buy-tariff'),
            afterUpdate: continueFileLoading,
        });
    }, [showTariffType, goToSubscriptions, closeModal]);

    return {
        onSkip,
        onRequestPayment,
        onClose,
    };
};
